import Alpine from 'alpinejs'

// CSS
import "./styles.css";

// Initialize Alpine.js
window.Alpine = Alpine
Alpine.start()

// Import any additional JavaScript modules here
// Example: import './components/mobile-menu.js'

// add icon classes to links based on their type
document.addEventListener('DOMContentLoaded', () => {
    const origin = window.location.origin;
    document.querySelectorAll('div.text-block a[href]').forEach(a => {
        try {
            const url = a.getAttribute('href');
            if (!url) return;
            // Create absolute URL for relative links
            const absUrl = new URL(url, origin);

            // Download-Asset-Link
            if (absUrl.pathname.startsWith('/assets/')) {
                a.classList.add('link-download');
            }
            // External Link
            else if (absUrl.origin !== origin) {
                a.classList.add('link-external');
            }
            // Internal Link (same origin, but not an asset)
            else {
                a.classList.add('link-internal');
            }
        } catch (e) {
            // Ignore invalid URLs
        }
    });
});
